import React from 'react'

import styled from 'styled-components/macro'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { GetServerSidePropsContext } from 'next'

import { Text } from '@/components/Text'

import { PageLayout } from '@/components/Layout/PageLayout'
import { Path } from '@/components/Path'
import { Button } from '@/components/Button'

import { initializeStore } from '../redux/store'
import { getSettings } from '../redux/actions'

import { ColorsMap, device } from '@/utils/Theme'

import { StateInterface } from '@/types/State'

import { CONTACTS } from '@/static/General'
import Link from 'next/link'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 14%;
  margin-bottom: 4rem;
`

const Container = styled.div`
  margin: 1rem;
  min-width: 15rem;
`

const BrandWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  @media (max-width: ${device.tablet}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${device.mobile}) {
    grid-template-columns: 1fr;
  }
`

const CompanyDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem 0;
`

const MapWrapper = styled.div`
  margin: 0 auto;

  iframe {
    width: 40rem;
    height: 35rem;
  }
`

const ContactPage = ({ state }) => {
  const { t, lang } = useTranslation('common')

  const contactSections = CONTACTS.map((section) => (
    <Container>
      <Text textColor={ColorsMap.brownishGrey} fontWeight="bold" m="0.5rem 0">
        {Array.isArray(section.title) && section.title.length >= 2 && section.title[1] === true
          ? t(section.title[0] as string)
          : (section.title as string)}
        :
      </Text>
      {section.contacts.map((contact) => (
        <>
          <Text m="0.5rem 0">
            {contact.name}, {contact.phone}
          </Text>
          <Text m="0.5rem 0">{contact.email}</Text>
        </>
      ))}
    </Container>
  ))

  const getTranslatedData = (lang) => {
    switch (lang) {
      case 'sk':
        return (
          <>
            <Container>
              <Text mb="1rem">Prevádzkovateľ internetového obchodu je spoločnosť SINTRA šport, s.r.o.</Text>
              <Text textColor={ColorsMap.primary} fontWeight="bold" mb="0.5rem">
                Fakturačná adresa (adresa sídla spoločnosti):
              </Text>
              <Text>SINTRA šport, s.r.o.</Text>
              <Text>Pluhová 2</Text>
              <Text>831 03 Bratislava</Text>
              <Text>Slovenská republika</Text>
              <Text my="1rem">email: info@sintrasport.sk</Text>
              <Text my="1rem">(pondelok - piatok: 08:00 - 16:00)</Text>
            </Container>
            <BrandWrapper>{contactSections}</BrandWrapper>
            <CompanyDataWrapper>
              <Container>
                <Text textColor={ColorsMap.primary} fontWeight="bold" mb="0.5rem">
                  Bankové spojenie:
                </Text>
                <Text>Peňažný ústav: Tatra banka, a.s.</Text>
                <Text>IBAN: SK8611000000002627845647</Text>
                <Text>KS: 0008</Text>
                <Text>VS: číslo faktúry</Text>
              </Container>
              <Container>
                <Text>IČO: 35935448</Text>
                <Text>DIČ: 2022001839</Text>
                <Text>IČ DPH: SK2022001839</Text>
                <Text>Spoločnosť SINTRA šport, s.r.o. je platcom DPH.</Text>
                <Text>Všetky ceny v našom obchode (maloobchod) sú zmluvné, uvádzané s DPH a sú konečné.</Text>
              </Container>
              <Container>
                <Text textColor={ColorsMap.primary} fontWeight="bold" mb="0.5rem">
                  Miesto pre osobný odber (adresa prevádzky):
                </Text>
                <Text>SINTRA šport, s.r.o.</Text>
                <Text>Zlatovská 1962</Text>
                <Text>911 05 Trenčín</Text>
                <Text>Slovenská republika</Text>
              </Container>
              <Container>
                <Text textColor={ColorsMap.primary} fontWeight="bold" mb="0.5rem">
                  Ekonomické oddelenie:
                </Text>
                <Text m="0.5rem 0">Eva Majdúchová +421 905 361 890</Text>
                <Text m="0.5rem 0">eva@tn.sintra.sk</Text>
              </Container>
              <Container>
                <Text>Zápis v OR: Okresný súd [Bratislava I]</Text>
                <Text>Oddiel Sro, vložka číslo: [36034]/B</Text>
              </Container>
            </CompanyDataWrapper>
          </>
        )
      case 'en':
        return (
          <>
            <Container>
              <Text mb="1rem">Owner of this e-shop is SINTRA šport, s.r.o.</Text>
              <Text textColor={ColorsMap.primary} fontWeight="bold" mb="0.5rem">
                Address:
              </Text>
              <Text>SINTRA šport, s.r.o.</Text>
              <Text>Pluhová 2</Text>
              <Text>831 03 Bratislava</Text>
              <Text>Slovakia</Text>
              <Text my="1rem">email: info@sintrasport.sk</Text>
              <Text my="1rem">(monday - friday: 08:00 - 16:00)</Text>
            </Container>
            <BrandWrapper>{contactSections}</BrandWrapper>
            <CompanyDataWrapper>
              <Container>
                <Text textColor={ColorsMap.primary} fontWeight="bold" mb="0.5rem">
                  Banking contact:
                </Text>
                <Text>Bank: Tatra banka, a.s.</Text>
                <Text>IBAN: SK8611000000002627845647</Text>
                <Text>KS: 0008</Text>
                <Text>VS: invoice number</Text>
              </Container>
              <Container>
                <Text>IČO: 35935448</Text>
                <Text>DIČ: 2022001839</Text>
                <Text>IČ DPH: SK2022001839</Text>
                <Text>Company SINTRA šport, s.r.o. is registered VAT payer.</Text>
                <Text>All prices in this e-shop are shown with VAT and final.</Text>
              </Container>
              <Container>
                <Text textColor={ColorsMap.primary} fontWeight="bold" mb="0.5rem">
                  Personal pick-up address:
                </Text>
                <Text>SINTRA šport, s.r.o.</Text>
                <Text>Zlatovská 1962</Text>
                <Text>911 05 Trenčín</Text>
                <Text>Slovakia</Text>
              </Container>
              <Container>
                <Text textColor={ColorsMap.primary} fontWeight="bold" mb="0.5rem">
                  Economic department:
                </Text>
                <Text m="0.5rem 0">Eva Majdúchová +421 905 361 890</Text>
                <Text m="0.5rem 0">eva@tn.sintra.sk</Text>
              </Container>
              <Container>
                <Text>Zápis v OR: Okresný súd [Bratislava I]</Text>
                <Text>Oddiel Sro, vložka číslo: [36034]/B</Text>
              </Container>
            </CompanyDataWrapper>
          </>
        )
      default:
        return null
    }
  }

  return (
    <PageLayout title={`${t('title:contact')} | ${state.settings.name}`}>
      <Path pathLinks={[<span>{t('contact')}</span>]} />
      <Wrapper>
        <Text as="h1" fontSize="xl" textColor={ColorsMap.primary} fontWeight="bold" m="2.5rem auto">
          {t('contact-title')}
        </Text>
        {getTranslatedData(lang)}
        <MapWrapper>
          <iframe
            src="https://www.google.com/maps/embed?origin=mfe&pb=!1m3!2m1!1s48.888561107333445,+18.010037487324023!6i15"
            frameBorder="0"
            title="Map"
          />
        </MapWrapper>
      </Wrapper>
    </PageLayout>
  )
}

const mapStateToProps = (state: StateInterface) => ({
  state,
})

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  const token = ctx.req.cookies.token || null

  await dispatch(getSettings({ token }))
  return { props: { initialReduxState: reduxStore.getState() } }
}

export default connect(mapStateToProps)(ContactPage)

